import { Grid } from "@mui/material";
import { addDays, addYears, format, isToday, isTomorrow, subDays } from "date-fns";
import React, { useState } from "react";
import "./style.scss";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import pl from "date-fns/locale/pl";
import ModalComponent from "../../../../features/ModalComponent";
import { DayPicker } from "react-day-picker";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import EAIconButton from "../Buttons/EAIconButton";

interface IProps {
  selectedDate: Date;
  setSelectedDate: (value: Date) => void;
}

const SingleDateSelector: React.FC<IProps> = ({ selectedDate, setSelectedDate }) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const locale = useLocaleByLanguage();

  const getDateLabel = () => {
    if (isToday(selectedDate)) {
      return "Dzisiaj";
    } else if (isTomorrow(selectedDate)) {
      return "Jutro";
    } else {
      return format(selectedDate, "EEEE dd.MM", { locale: pl });
    }
  };

  const handlePreviousDay = () => {
    setSelectedDate(subDays(selectedDate, 1));
  };

  const handleNextDay = () => {
    setSelectedDate(addDays(selectedDate, 1));
  };

  const handleSelectDate = (date: Date) => {
    setSelectedDate(date);
    setOpenCalendar(false);
  };

  return (
    <>
      <div className="single-date-select-wrapper">
        {!isToday(selectedDate) && (
          <EAIconButton title="Poprzedni dzień" onClick={handlePreviousDay} icon={<MdOutlineKeyboardArrowLeft />} />
        )}

        <div className="date-label" onClick={() => setOpenCalendar(true)}>
          {getDateLabel()}
        </div>
        <EAIconButton title="Następny dzień" onClick={handleNextDay} icon={<MdOutlineKeyboardArrowRight />} />
      </div>

      {openCalendar && (
        <ModalComponent
          footer
          open
          closeModal={() => setOpenCalendar(false)}
          title="Wybór dnia"
          onAccept={() => handleSelectDate(selectedDate)}
        >
          <Grid container justifyContent="center">
            <DayPicker
              mode="single"
              locale={locale}
              fromDate={new Date()}
              selected={selectedDate}
              onSelect={(date) => handleSelectDate(date ? date : new Date())}
              showOutsideDays
              toDate={addYears(new Date(), 1)}
            />
          </Grid>
        </ModalComponent>
      )}
    </>
  );
};

export default SingleDateSelector;
